module.exports = __webpack_public_path__ + "static/media/26.0f253341.jpg";